import { cn } from '@/lib/utils';

interface InternalLinkProps {
  to: `/${string}`;
  text: string;
  className?: string;
}

function InternalLink({ to, text, className }: InternalLinkProps) {
  return (
    <a href={to} className={cn('text-text-link hover:text-text-link-hovered', className)}>
      {text}
    </a>
  );
}

export { InternalLink };
